import {
  descriptionUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import ServiceConnectedDisabilityAddtlInfo from '../../components/FormDescriptions/ServiceConnectedDisabilityAddtlInfo';
import {
  blankSchema,
  DEFAULT_TITLE_OPTS,
  titleWithRoleUI,
} from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['eligibility--disability-title'];
const INPUT_LABEL = content['eligibility--disability-label--deceased'];

export default {
  uiSchema: {
    ...titleWithRoleUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.sponsor),
    'view:sponsorIsDisabled': yesNoUI({
      title: INPUT_LABEL,
      enableAnalytics: true,
    }),
    'view:addtlInfo': descriptionUI(ServiceConnectedDisabilityAddtlInfo),
  },
  schema: {
    type: 'object',
    required: ['view:sponsorIsDisabled'],
    properties: {
      'view:sponsorIsDisabled': yesNoSchema,
      'view:addtlInfo': blankSchema,
    },
  },
};
